<template>
  <div>
    <div class="modal-backdrop"></div>
    <div class="modal">
      <div class="pull-right">
        <div class="btn-close" @click="close"></div>
      </div>
      <div class="content">
        <h1>{{ title }}</h1>
        <div class="message-wrapper" v-for="m in message" :key="m">
          <p class="message">
            {{ m }}
          </p>
          <br />
        </div>
        <button class="button" @click="close">{{ buttonCaption }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalServiceNA',
  props: {
    title: String,
    message: Array,
    buttonCaption: String,
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
  created() {
    // Add class to make background fixed
    document.body.classList.add('modal-open');
  },
  destroyed() {
    // remove class that makes background fixed
    document.body.classList.remove('modal-open');
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgb(51 52 54);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  opacity: 0.95;
}

.modal {
  background: #ffffff;
  border-radius: 4px;
  display: block;
  width: 50%;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  left: 25%;
  top: 15%;
  height: fit-content;
}

.content {
  text-align: center;
  font-family: 'Open Sans', open-sans, sans-serif;
  margin-top: 40px;
}

.content > h1 {
  font-size: 29px;
  margin-top: 0px;
  color: #333c4e;
  font-weight: 300;
}

input {
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  width: 290px;
  padding-bottom: 15px;
  margin-bottom: 0;
  height: 51px;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 400px;
  width: 500px;
  overflow: hidden;
}

.message-wrapper {
  padding: 0 25px;
  word-break: break-all;
}

.message {
  font-size: 16px;
  color: #7e8890;
  line-height: 28px;
  font-weight: 400;
  margin: 0;
  padding: 15px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  display: block;
  margin-block-start: 0.83em;
  margin-block-end: 0.83em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-family: 'Open Sans', open-sans, sans-serif;
  color: #5f697a;
  max-height: 500px;
  overflow-y: auto;
}

button.default {
  color: #464d5d;
  background: #fff;
  border: 1px solid #dee3e9;
  border-radius: 3px 3px 3px 3px;
  width: 99px;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  margin-bottom: 40px;
}

.input-group > button {
  min-width: 0;
  width: 99px;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  color: #fff;
  background: #6bbc7c;
  border: 1px solid #5ab36c;
  margin-bottom: 0;
  border-radius: 0 3px 3px 0;
}

.pull-right {
  float: right;
  margin: 15px 15px 0 0;
}

.button {
  font-family: 'Inv Maison Neue', 'Maison Neue', -apple-system,
    BlinkMacSystemFont, 'Open Sans', open-sans, sans-serif;
  background: rgb(255, 51, 102);
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.125px;
  border-radius: 32px;
  padding: 16px 30px 15px;
  -webkit-font-smoothing: antialiased;
  outline: 0;
  border-width: 0;
  border-style: none;
  margin-bottom: 40px;
}
</style>
